const state = {
    addBoxWindow_Visual:false,
    addEleBoxWindow_Visual:false
}
const getters = {
    getter_addBoxWindow_Visual() {
        return state.addBoxWindow_Visual
    }
}
const mutations = {
    change_addBoxWindow_Visual(state, param) {
        state.addBoxWindow_Visual = param.visual;
    },
    change_addEleBoxWindow_Visual(state, param) {
        state.addEleBoxWindow_Visual = param.visual;
    }
}
const actions = {
    change_addEleBoxWindow_Visual: ({
        commit
    }, param) => {
        commit("change_addEleBoxWindow_Visual", param);
    },
    change_addBoxWindow_Visual: ({
        commit
    }, param) => {
        commit("change_addBoxWindow_Visual", param);
    }
}

export default {
state,
getters,
mutations,
actions
};